module.exports = __webpack_public_path__ + "img/icon_tag102.878870a6.svg";